export default __webpack_public_path__ + "static/icon-31-4-300d7ab201bb25c6b6042d95fc05c570.png";